<template>
  <div>
    <PageDynamicBreadcrumb custom-current-page="Overview" />
    <PageHeader title="Insurance Agents Overview" />

    <DataTable
      table-key="insuranceAgentsOverview"
      row-key="id"
      title=""
      :columns="columns"
      :rows="businesses"
      :loading="loading"
      :pagination="pagination"
      :downloadable="true"
      :refreshable="false"
      :customizable="false"
      :filterable="true"
      :searchable="true"
      :disable-state="true"
    >
      <template v-slot:actions="row">
        <ActionsDropdownButton
          :actions="generateBusinessActions(row)"
        />
      </template>
    </DataTable>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/PageHeader";
import PageDynamicBreadcrumb from "@/components/UI/PageDynamicBreadcrumb";
import DataTable from "@/components/DataTable";
import ActionsDropdownButton from "@/components/UI/ActionsDropdownButton";
import axios from "axios";

export default {
  name: "InsuranceAgentsOverview",
  components: {
    ActionsDropdownButton,
    DataTable,
    PageDynamicBreadcrumb,
    PageHeader
  },
  data() {
    return {
      loading: true,
      filter: "",
      businesses: [],
      pagination: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 25
      },
      columns: [
        {
          name: "id",
          label: "Business ID",
          field: "id",
          sortable: true,
          sort: (a, b) => this.sortInteger(a, b),
          type: "dimension",
          filterable: false
        },
        {
          name: "name",
          label: "Name",
          field: "name",
          sortable: true,
          filterable: false,
          type: "dimension"
        },
        {
          name: "phone",
          label: "Phone Number",
          field: "phone",
          format: val => this.formatPhoneNumber(val),
          sortable: true,
          sort: (a, b) => this.sortInteger(a, b),
          type: "dimension",
          filterable: false
        },
        {
          name: "website_url",
          label: "Website Url",
          field: row => row.website_url.length > 0 ? row.website_url : "-",
          sortable: true,
          type: "dimension",
          filterable: false
        },
        {
          name: "address",
          label: "Address",
          field: "address",
          sortable: true,
          filterable: false,
          type: "dimension"
        },
        {
          name: "city",
          label: "City",
          field: "city",
          sortable: true,
          type: "dimension"
        },
        {
          name: "state",
          label: "State",
          field: "state",
          sortable: true,
          type: "dimension"
        },
        {
          name: "postal_code",
          label: "Postal Code",
          field: "postal_code",
          sortable: true,
          type: "dimension"
        },
        {
          name: "actions",
          label: "",
          field: "",
          filterable: false
        }
      ]
    };
  },
  computed: {},
  mounted() {
    this.getBusinesses();
  },
  methods: {
    getBusinesses() {
      this.loading = true;

      axios("http://localhost:8082/internal/insurance-agents/businesses")
        .then(resp => {
          this.businesses = resp.data.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateBusinessActions(business) {
      return [
        {
          action: () => window.open("https://agents-dashboard.jumpfeed.com/sign-in?bid=" + business.id, "_blank"),
          label: "Configure Account"
        }
      ];
    }
  }
};
</script>

<style scoped lang="scss"></style>
